<template>
	<!-- 帮助中心 -->
	<div class="allgame-mainbox">
		<div class="box_center">
			<div class="helpcenter_main box_h">
				<!-- 左侧列表 -->
				<div class="helpcenter_list_box">
					<!-- 颜色块 -->
					<div class="helpcenter_zw_box"></div>
					<!-- 列表内容 -->
					<ul class="helpcenter_ul_list">
						<li class="helpcenter_title_box">
							<div class="helpcenter_title">{{ SysValue }}</div>
						</li>
						<!-- 选中样式 -->
						<li class="helpcenter_title_box">
							<router-link to="/first" class="helpcenter_navlist">关于{{ SysValue }}</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/second" class="helpcenter_navlist">彩种介绍</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/three" class="helpcenter_navlist">玩法介绍</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/four" class="helpcenter_navlist">责任博彩</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/five" class="helpcenter_navlist">如何充值</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/six" class="helpcenter_navlist">提款须知</router-link>
						</li>
						<li class="helpcenter_title_box">
							<router-link to="/sven" class="helpcenter_navlist">使用条款</router-link>
						</li>
					</ul>
				</div>
				<!-- 右侧内容 -->
				<div class="helpcontent_mainbox box_flex">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { SysKey } from "../../util/sysconfig";

export default {
	data() {
		return {
			SysValue: SysKey("SysName").SysValue,
		};
	},
};
</script>
<style>
.allgame-mainbox {
	padding-bottom: 0;
}

.helpcenter_main {
	width: 100%;
	margin: 20px 0;
	background: #fff;
	overflow: hidden;
}

/* 左侧列表 */
.helpcenter_list_box {
	width: 220px;
	margin-right: 20px;
	border-radius: 2px;
	overflow: hidden;
}

.helpcenter_ul_list {
	overflow: hidden;
	text-align: center;
}

.helpcenter_title_box {
	background-color: #fcfcfc;
}

.helpcenter_title_box .helpcenter_title {
	line-height: 60px;
	height: 60px;
	color: #333;
	font-size: 16px;
	background: #f2f2f2 url(~@/static/img/icon/helpcenter.webp) no-repeat center left 50px;
}

.helpcenter_navlist {
	color: #333;
	display: block;
	height: 50px;
	line-height: 50px;
	border-right: 3px solid transparent;
	font-size: 16px;
	text-align: center;
}

.helpcenter_navlist.router-link-active,
.helpcenter_navlist:hover {
	border-right: 3px solid #1e8edd;
	background: #1e8edd;
	color: white;
}

/* 右侧内容框 */
.helpcontent_mainbox {
	width: 834px;
	min-height: 410px;
	height: calc(100vh - 76px - 40px);
	border-radius: 2px;
	overflow-y: auto;
	overflow-x: hidden;
}

/* 帮助中心子路由盒子 */
.helpcontent_mainbox .helpcenter_item1_title {
	height: 60px;
	line-height: 58px;
	background-color: #f2f2f2;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/helpcenter/helpcenter.vue